import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { MatTableDataSource, MatDialog, PageEvent, MatPaginator } from '@angular/material';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ComponentPageTitle } from 'src/app/page-title/page-title.component';
import { AppServiceService } from 'src/app/services/app-service.service';
import { BusquedaService } from '../busqueda.service';
import { CreateService } from '../createservice';
import { GatewayService } from 'src/app/gateway.service';
import { FiltroPaisService } from '../filtro-pais.service';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatSnackBar } from '@angular/material';
import { FormGroup, FormControl } from '@angular/forms';
import { DescargarLotesComponent } from 'src/app/home/descargar-lotes/descargar-lotes.component';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'app-citas-suspendidas',
  templateUrl: './citas-suspendidas.component.html',
  styleUrls: ['./citas-suspendidas.component.scss']
})
export class CitasSuspendidasComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  agentes = [];
  agentesFiltrados: any[] = [];
  searchTecnico = '';
  contratasagente = [];

  grupoVal = new FormGroup({
    BUSCAR: new FormControl(''),
    CONTRATA_TECNICO: new FormControl([]),
    AGENTE: new FormControl([]),
    TIEMPO: new FormControl(0),
    FECHAINI: new FormControl(null),
    FECHAFIN: new FormControl(null),
  });

  tiempos = [
    { id: 0, name: 'Todos' },
    { id: 'AM', name: 'AM' },
    { id: 'PM', name: 'PM' }
  ];

  tableColumns: string[] = ['ID', 'TIPO', 'FALLA', 'CASO', 'ESTADO', 'ADM_CONTRATA', 'CONTRATA', 'AGENTE', 'CUENTA', 'DIRECCION', 'FECHAVISITA', 'AMPM', 'ORDEN', 'BOX'];
  dataSource = new MatTableDataSource<any>([]);
  private subscription: Subscription;
  private subscriptioncreate: Subscription;
  private subscriptionpais: Subscription;
  FILTER; resultsLength = 0;
  pageSize = 10;
  idpais;
  pageEvent: PageEvent;
  public actpage: number = 0;
  @ViewChild('paginatortable') paginatortable: MatPaginator;

  constructor(
    private router: Router,
    private spinner: NgxSpinnerService,
    private gateway: GatewayService,
    public pageTitle: ComponentPageTitle,
    public _appservice: AppServiceService,
    public _busqueda: BusquedaService,
    public _create: CreateService,
    private dialog: MatDialog,
    public _filtroPais: FiltroPaisService,
    private localSave: LocalSaveService,
    private snackbar: MatSnackBar,
    private configService: ConfigService,
  ) { }

  async ngOnInit() {
    // Feature flag removed - module always enabled
    const user = this.localSave.get('usuarioPGV');
    await this.getTecnicosxContrata();
    this.getContratasAgente();
    const permisos = user ? (user.permisos || []) : [];
    const tienePermiso = permisos.some(p => p.modulo === 'CITAS_SUSPENDIDAS' && p.permiso_ver === 1);
    if (!user || (!user.esDistribuidor && !user.esSuperAdmin && user.idrol != 1 && user.idrol != 23 && user.idrol != 24 && user.idrol != 27 && !tienePermiso)) {
      this.router.navigate(['/home']);
    }
    this.idpais = this.localSave.get('pais');
    this.get(0);
    this.pageTitle.title = 'Citas Suspendidas';

    this.subscription = this._busqueda.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
      res => {
        this.filtrarAgente(res.filtro);
      });
    this.subscriptioncreate = this._create.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(res => { });
    this.subscriptionpais = this._filtroPais.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
      res => {
        this.idpais = res.IDPAIS;
        this.get(0);
      }
    );
  }

  // ============== FILTRO ==============
  filter = '';
  public keyDownFunction(event) {
    if (event.keyCode == 13) {
      this.filtrogeneral();
    } else if (event.keyCode == 8 && this.filter == '') {
      this.filtrogeneral();
    }
  }

  public filtrogeneral() {
    if (this.paginatortable) {
      this.paginatortable.firstPage();
    }
    this._busqueda.notificarBusqueda({ filtro: this.filter });
  }

  onContrataSeleccionada(event: any) {
    this.gateway.get('gettecnicosxcontrata_suspendidas', {
      IDCONTRATA2: this.localSave.get('usuarioPGV').IDCONTRATA2 || this.getContrataValue(event.value),
    }).then((result) => {
      let aux: any = result;
      if (aux.rows.length > 0) {
        this.agentes = aux.rows;
        this.filtrarTecnicos();
      }
    }).catch((e) => { });
  }

  getContratasAgente() {
    this.gateway.get('getContrata', {
      NUM_PAGINA: 0, FILTRO: this.FILTER, NUM_ELEMENTOS: 5,
      IDPAIS: this.idpais,
    }).then((result) => {
      let aux: any = result;
      this.contratasagente = aux.rows;
    }).catch((e) => { });
  }

  limpiarFiltros() {
    this.grupoVal.reset();
    this.grupoVal.controls.AGENTE.setValue([]);
    this.grupoVal.controls.CONTRATA_TECNICO.setValue([]);
    this.grupoVal.controls.TIEMPO.setValue(0);
    this.grupoVal.controls.FECHAINI.setValue(null);
    this.grupoVal.controls.FECHAFIN.setValue(null);
    this.filter = '';
    this.FILTER = null;
    this.get(0);
  }

  private getContrataValue(val?: any): any {
    const v = val !== undefined ? val : this.grupoVal.get('CONTRATA_TECNICO').value;
    return (Array.isArray(v) && v.length > 0) ? v : (v && !Array.isArray(v)) ? v : null;
  }

  private getAgenteValue(): any {
    const v = this.grupoVal.get('AGENTE').value;
    return (Array.isArray(v) && v.length > 0) ? v : (v && !Array.isArray(v)) ? v : null;
  }

  filtrarTecnicos() {
    const term = (this.searchTecnico || '').trim().toLowerCase();
    if (!term) {
      this.agentesFiltrados = this.agentes;
    } else {
      this.agentesFiltrados = this.agentes.filter(a =>
        a.nombre.toLowerCase().includes(term)
      );
    }
  }

  onTecnicoDropdownToggle(opened: boolean) {
    if (opened) {
      this.searchTecnico = '';
      this.filtrarTecnicos();
    }
  }

  getTecnicosxContrata() {
    return new Promise((resolve, reject) => {
      this.gateway.get('gettecnicosxcontrata_suspendidas', {
        IDCONTRATA2: this.localSave.get('usuarioPGV').IDCONTRATA2,
      }).then((result) => {
        let aux: any = result;
        if (aux.rows.length > 0) {
          this.agentes = aux.rows;
          this.filtrarTecnicos();
          resolve(true);
        } else {
          resolve(false);
        }
      }).catch((e) => { reject(e); });
    });
  }

  get(page) {
    this.spinner.show();
    this.gateway.get('getcitassuspendidas', {
      IDAGENTE: this.getAgenteValue(),
      TIEMPO: this.grupoVal.controls.TIEMPO.value,
      FECHAINI: this.grupoVal.controls.FECHAINI.value,
      FECHAFIN: this.grupoVal.controls.FECHAFIN.value,
      NUM_PAGINA: page,
      FILTRO: this.FILTER,
      NUM_ELEMENTOS: this.pageSize,
      IDPAIS: this.idpais,
      IDCONTRATA2: this.localSave.get('usuarioPGV').IDCONTRATA2 || this.getContrataValue(),
    }).then((result) => {
      let aux: any = result;
      this.dataSource = aux.rows;

      this.gateway.get('getcountcitassuspendidas', {
        IDAGENTE: this.getAgenteValue(),
        TIEMPO: this.grupoVal.controls.TIEMPO.value,
        FECHAINI: this.grupoVal.controls.FECHAINI.value,
        FECHAFIN: this.grupoVal.controls.FECHAFIN.value,
        FILTRO: this.FILTER,
        NUM_PAGINA: page,
        NUM_ELEMENTOS: this.pageSize,
        IDPAIS: this.idpais,
        IDCONTRATA2: this.localSave.get('usuarioPGV').IDCONTRATA2 || this.getContrataValue(),
      }).then((result: any) => {
        this.resultsLength = result.rows[0].total;
        this.spinner.hide();
      });
    }).catch((e) => {
      this.spinner.hide();
    });
  }

  public descargar() {
    const dialogRef = this.dialog.open(DescargarLotesComponent, {
      disableClose: true,
      width: '700px',
      data: {
        cantPorPagina: 1000,
        nombreServicioCantRegistros: 'getcountcitassuspendidas',
        nombreServicioRegistros: 'getcitassuspendidasdescarga',
        params: {
          IDAGENTE: this.getAgenteValue(),
          TIEMPO: this.grupoVal.controls.TIEMPO.value,
          FECHAINI: this.grupoVal.controls.FECHAINI.value,
          FECHAFIN: this.grupoVal.controls.FECHAFIN.value,
          FILTRO: this.FILTER,
          IDPAIS: this.idpais,
          IDCONTRATA2: this.localSave.get('usuarioPGV').IDCONTRATA2 || this.getContrataValue(),
        }
      }
    });
    dialogRef.afterClosed().subscribe((resp) => { });
  }

  cambioElementos(event?: PageEvent) {
    this.actpage = event.pageIndex;
    this.get(event.pageIndex);
  }

  filtrarAgente(data) {
    this.FILTER = data;
    this.get(0);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.subscription) this.subscription.unsubscribe();
    if (this.subscriptioncreate) this.subscriptioncreate.unsubscribe();
    if (this.subscriptionpais) this.subscriptionpais.unsubscribe();
  }
}
